import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

let routes = [];

// 通配符404页面
const wildcardRoutes = {
  path: '*',
  name: '*',
  // hidden: true,
  meta: {
    layout: 'error',
    title: '错误页面'
  },
  component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue')
};

// 引入所有路由文件
function importAll(r) {
  r.keys().forEach((path) => routes.push(r(path).default || r(path)));
}
importAll(require.context('@/router/', true, /\.router\.js/));

routes.push(wildcardRoutes);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
